// ============================================
// INFRASTRUCTURE - Permisos Repository
// ============================================
// Módulo genérico de permisos por usuario. Hoy solo existen valores de caja
// en el catálogo, pero el repositorio no asume nada de caja — otros módulos
// reusan estos mismos endpoints con sus propios valores de PermisoCaja/enum.

import { axiosClient } from './axios-client';
import type { PermisoCatalogoItem, PermisoCaja } from '../../domain/dtos';

export const permisosRepository = {
  /**
   * Catálogo de permisos disponibles, opcionalmente filtrado por módulo
   * (solo propietario)
   * GET /permisos/catalogo
   */
  async obtenerCatalogo(moduloCodigo?: string): Promise<PermisoCatalogoItem[]> {
    const params = moduloCodigo ? { modulo: moduloCodigo } : undefined;
    const { data } = await axiosClient.get<PermisoCatalogoItem[]>('/permisos/catalogo', { params });
    return data;
  },

  /**
   * Permisos efectivos del usuario autenticado actual (cualquiera) — si es
   * propietario, el backend ya devuelve el catálogo completo.
   * GET /permisos/mis-permisos
   */
  async obtenerMisPermisos(): Promise<PermisoCaja[]> {
    const { data } = await axiosClient.get<PermisoCaja[]>('/permisos/mis-permisos');
    return data;
  },

  /**
   * Permisos actuales de un vendedor puntual del almacén (solo propietario)
   * GET /permisos/usuarios/{usuarioId}
   */
  async obtenerPermisosDeUsuario(usuarioId: number): Promise<PermisoCaja[]> {
    const { data } = await axiosClient.get<PermisoCaja[]>(`/permisos/usuarios/${usuarioId}`);
    return data;
  },

  /**
   * Otorgar un permiso puntual a un vendedor (solo propietario)
   * POST /permisos/usuarios/{usuarioId}
   */
  async asignarPermiso(usuarioId: number, permiso: PermisoCaja): Promise<void> {
    await axiosClient.post(`/permisos/usuarios/${usuarioId}`, { permiso });
  },

  /**
   * Revocar un permiso puntual a un vendedor (solo propietario)
   * DELETE /permisos/usuarios/{usuarioId}/{permiso}
   */
  async revocarPermiso(usuarioId: number, permiso: PermisoCaja): Promise<void> {
    await axiosClient.delete(`/permisos/usuarios/${usuarioId}/${permiso}`);
  },
};
